<template>
    <lightbox-gallery
        class="lightbox-media-gallery"
        :showing="showing"
        :index="index"
        :can-slide-past-first="canSlidePastFirst"
        :can-slide-past-last="canSlidePastLast"
        @update:showing="emitShowing($event)"
        @update:index="emitIndex($event)"
        @close="emitClose()"
        @slide-past-first="emitSlidePastFirst()"
        @slide-past-last="emitSlidePastLast()">

        <lightbox-media-gallery-slide
            :media="m"
            v-for="m in media">
        </lightbox-media-gallery-slide>

    </lightbox-gallery>
</template>

<script>
    import LightboxGallery from './gallery';
    import LightboxMediaGallerySlide from './media-gallery-slide';

    /**
     * Events:
     *  - update:index
     *  - update:showing
     *  - close (alias of update:showing)
     *  - slide-past-first
     *  - slide-past-last
     */

    /**
     * @typedef {object} Media
     * @property {string} type
     * @property {string} [url]
     * @property {string} [html]
     * @property {string} [caption]
     *
     * Supported types:
     *  - iframe    (requires `html`)
     *  - image     (requires `url`)
     *  - marmoset  (requires `url`)
     *  - sketchfab (requires `url`)
     *  - video     (requires `url`)
     */

    export default {
        props: {
            media: {
                type: Array, // Media[] (see above)
                required: true,
            },

            showing: {
                type: Boolean,
                required: true,
            },

            index: {
                type: Number,
            },

            canSlidePastFirst: {
                type: Boolean,
                default: false,
            },

            canSlidePastLast: {
                type: Boolean,
                default: false,
            },
        },

        components: {
            LightboxGallery,
            LightboxMediaGallerySlide,
        },

        methods: {
            emitIndex(ev) {
                this.$emit('update:index', ev);
            },

            emitShowing(ev) {
                this.$emit('update:showing', ev);
            },

            emitClose() {
                this.$emit('close');
            },

            emitSlidePastFirst() {
                this.$emit('slide-past-first');
            },

            emitSlidePastLast() {
                this.$emit('slide-past-last');
            },
        },
    }
</script>



// WEBPACK FOOTER //
// media-gallery.vue?bd86e654